import { render, staticRenderFns } from "./WizardStep3.vue?vue&type=template&id=7998c72e&scoped=true"
import script from "./WizardStep3.vue?vue&type=script&lang=js"
export * from "./WizardStep3.vue?vue&type=script&lang=js"
import style0 from "./WizardStep3.vue?vue&type=style&index=0&id=7998c72e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7998c72e",
  null
  
)

export default component.exports